import styled from 'styled-components';

import { Backdrop, Drawer, Text14, Text18SB } from '@sternum/ui';
import { Icon } from '@sternum/web/components';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

const LeftRightPadding = 16;

export const DrawerStyled = styled(Drawer)`
  display: grid;
  grid-template-areas: 'header' 'content' 'footer';
  grid-template-rows: auto 1fr auto;
  padding: 0;
  z-index: 600;
`;

export const BackdropStyled = styled(Backdrop)`
  z-index: 550;
`;

export const Header = styled.div`
  grid-area: header;
  padding: 12px ${LeftRightPadding}px;
  border-bottom: 1px solid ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
  overflow: auto;
`;

export const Content = styled.div`
  grid-area: content;
  overflow: auto;
`;

export const Footer = styled.div`
  grid-area: footer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
`;

export const CloseIcon = styled(Icon)`
  position: absolute;
  top: 15px;
  right: 19px;
  color: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.GreyDarkest })};
`;

export const Title = styled(Text18SB)`
  color: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
  margin-bottom: 4px;
`;

export const Subtitle = styled(Text14)`
  color: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.GreyDarkest })};
  margin-right: 40px;
`;

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
`;
